var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content-c"},[_c('img',{staticClass:"load-img",attrs:{"src":require("../assets/images/loading.gif"),"mode":""}}),_c('div',{staticClass:"load-text color-9"},[_vm._v(_vm._s(_vm.$t('msgLoading')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }